export interface GoogleAdsAccountIdentity {
  connectionId: string;
  customerId: string;
}

export function googleAdsAccountKey(identity: GoogleAdsAccountIdentity): string {
  return `${identity.connectionId}:${identity.customerId}`;
}

export function parseGoogleAdsAccountKey(value: string | null): {
  connectionId: string | null;
  customerId: string | null;
} {
  if (!value) return { connectionId: null, customerId: null };
  const separator = value.lastIndexOf(':');
  if (separator < 1 || separator === value.length - 1) {
    return { connectionId: null, customerId: value };
  }
  return {
    connectionId: value.slice(0, separator),
    customerId: value.slice(separator + 1),
  };
}

export function buildGoogleAdsCampaignPath(
  identity: GoogleAdsAccountIdentity & { campaignId: string },
  surface: 'campaigns' | 'insights' = 'campaigns',
  days?: number,
): string {
  const segments =
    surface === 'campaigns'
      ? ['/campaigns/google-ads', identity.connectionId, identity.customerId, identity.campaignId]
      : [
          '/insights/google-ads',
          identity.connectionId,
          identity.customerId,
          'campaigns',
          identity.campaignId,
        ];
  const path = segments
    .map((segment, index) =>
      index === 0 || segment === 'campaigns' ? segment : encodeURIComponent(segment),
    )
    .join('/');
  return days ? `${path}?days=${days}` : path;
}
